// extracted by mini-css-extract-plugin
export default {"radioButton":"AlbumInfo_radioButton__2-J0n","keyButton":"AlbumInfo_keyButton__QbEQN"};